(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('portrait-video-popup')) {
  customElements.define('portrait-video-popup', class extends HTMLElement {
    connectedCallback() {
      if (this.listenerController) return;

      this.banner = document.getElementById(this.dataset.bannerId);
      this.dialog = this.querySelector('dialog');
      this.video = this.querySelector('video');
      this.desktopMarker = this.querySelector('[data-desktop-marker]');
      this.section = this.closest('.shopify-section');
      if (!this.banner || !this.dialog || !this.video || !this.desktopMarker || !this.section) return;

      this.listenerController = new AbortController();
      const signal = this.listenerController.signal;

      this.section.addEventListener('click', (event) => {
        const target = event.target;
        if (!(target instanceof Element) || !this.isDesktop() || !this.banner.contains(target)) return;
        if (!target.closest('video-media, .play-button') || target.closest('a')) return;
        if (typeof this.dialog.showModal !== 'function') return;

        event.preventDefault();
        event.stopImmediatePropagation();
        this.open(target.closest('button') || this.banner.querySelector('.play-button'));
      }, { capture: true, signal });

      this.querySelector('[data-close-popup]').addEventListener('click', () => this.dialog.close(), { signal });
      this.dialog.addEventListener('close', () => this.cleanUp(true), { signal });
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
          this.dialog.close();
        }
      }, { signal });

      window.addEventListener('resize', () => {
        if (this.dialog.open && !this.isDesktop()) this.dialog.close();
      }, { signal });
    }

    isDesktop() {
      return getComputedStyle(this.desktopMarker).display !== 'none';
    }

    open(trigger) {
      if (this.dialog.open) return;
      this.returnFocus = trigger || document.activeElement;
      this.dialog.showModal();

      const rootStyle = document.documentElement.style;
      this.previousOverflow = {
        value: rootStyle.getPropertyValue('overflow'),
        priority: rootStyle.getPropertyPriority('overflow')
      };
      this.previousGutter = {
        value: rootStyle.getPropertyValue('scrollbar-gutter'),
        priority: rootStyle.getPropertyPriority('scrollbar-gutter')
      };
      rootStyle.setProperty('scrollbar-gutter', 'stable');
      rootStyle.setProperty('overflow', 'hidden');
      this.hasScrollLock = true;

      // The popup owns desktop playback; keep any inline player paused.
      this.banner.querySelectorAll('video').forEach((video) => video.pause());
      this.video.muted = false;
      const playback = this.video.play();
      if (playback && typeof playback.catch === 'function') {
        // Native controls remain available if the browser requires another tap.
        playback.catch(() => {});
      }
    }

    cleanUp(restoreFocus) {
      this.video?.pause();
      if (this.video?.readyState > 0) this.video.currentTime = 0;

      if (this.hasScrollLock) {
        const rootStyle = document.documentElement.style;
        for (const [property, previous] of [['overflow', this.previousOverflow], ['scrollbar-gutter', this.previousGutter]]) {
          if (previous.value) rootStyle.setProperty(property, previous.value, previous.priority);
          else rootStyle.removeProperty(property);
        }
        this.hasScrollLock = false;
      }

      if (restoreFocus && this.returnFocus?.isConnected && this.isDesktop()) {
        this.returnFocus.focus({ preventScroll: true });
      }
      this.returnFocus = null;
    }

    disconnectedCallback() {
      this.listenerController?.abort();
      this.listenerController = null;
      if (this.dialog?.open) this.dialog.close();
      this.cleanUp(false);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
